module.exports = __webpack_public_path__ + "static/bank-CEB.d420a19f.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/bank-CEB.png
// module id = 974
// module chunks = 2